import {useTranslation} from "react-i18next";

export default function RegisterButton(
    {
        isUserRegistered,
        isStarted,
        id,
    }
) {
    const { t } = useTranslation();

    if (isStarted) {
        return null;
    }

    return (
        <a href={`/conference/${id}/registration`} className="btn-conference-page wide btn-primary">
            { isUserRegistered ? t('conferences.conference.buttons.registered') : t('conferences.conference.buttons.register') }
        </a>
    );
}
